import { render, staticRenderFns } from "./modal-success-payment.vue?vue&type=template&id=25dd1784&scoped=true&lang=pug"
import script from "./modal-success-payment.js?vue&type=script&lang=js&external"
export * from "./modal-success-payment.js?vue&type=script&lang=js&external"
import style0 from "./modal-success-payment.vue?vue&type=style&index=0&id=25dd1784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd1784",
  null
  
)

export default component.exports